import { createSlice } from '@reduxjs/toolkit'

type DocumentGroupConfig = {
    educational_documents: string;
    previous_employment_documents: string;
    identification_documents: string;
    personal_documents: string;
    other_documents: string;
    proof_of_address: string;
  };

type CandidateDocumentList = {
    [key in keyof DocumentGroupConfig]?: Document[];
  }; 
  type Document = {
    id: number;
    document_path: string[];
    document_type: string;
    document_status: string;
    is_log: string;
    document_remark: string;
    document_group: string;
    is_log_count: number;
  };

  type InitialState = {
    candidate_document_list: CandidateDocumentList[];
  };

const initialState: InitialState = {
    candidate_document_list:[]
}

const candidateAttachmentSlice = createSlice({
    name: 'candidateAttachment',
    initialState,
    reducers: {
        setCandidateDocumentList: (state, action) => {
            state.candidate_document_list=action.payload 
        }
    },
});

export const { setCandidateDocumentList } = candidateAttachmentSlice.actions;

export default candidateAttachmentSlice.reducer